<div class="w-100 d-flex flex-column align-items-center justify-content-start text-center">
  <p class="font-24 text-capitalize mb-2 fw-regular widget-title">{{ 'widget.claim_live' | translate }}</p>
  <p class="font-18 text-break  mb-2 fw-regular widget-title">{{ 'widget.claim_desc' | translate : {tokenAddress : saleToken} }}</p>

  <div class="usd-raised-box mt-2">
    <p class="font-13 mb-0 text-uppercase fw-light"> {{ 'widget.token_bonus_text' | translate }} </p>
    <p class="font-lg-30 font-24 mb-0 text-white">{{ 'widget.phase_text' | translate }}</p>
    <div class="nearly-raised d-flex justify-content-center align-items-center">{{"widget.near_capacity" | translate}}</div>
  </div>


  <div *ngIf="walletAddress" class="d-flex justify-content-center align-items-center text-center mb-2 font-14 px-3 mt-3 text-white" [ngClass]="{ shimmer: !raisedInfo.usdRaised || raisedInfo.usdRaised <= 0 }">
    <span class="text-uppercase">{{ 'widget.your_claimable' | translate: { tokenName } }}</span>
    <span> = {{ convertNum(raisedInfo.userClaimable) }}</span>
    <img src="/assets/images/svg-icons/info-icon.svg" class="img-fluid ms-2 cursor-pointer" (click)="yourPurchasedInfo()" alt="Info Icon" loading="eager" />
  </div>

</div>